import * as list from './list';
import * as single from './single';
import * as dataCenter from './data-center';
import * as currentDataCenter from './current-data-center';
import * as current from './current';

export default {
  ...list,
  ...single,
  ...dataCenter,
  ...currentDataCenter,
  ...current,
};
